// src/components/shell/AuthGate.jsx
import React, { useContext } from 'react';
import { UserContext } from '../../context/UserContext';
import LoginForm from '../LoginForm';
import '../../css/Feedback.css';

/**
 * Every signed-in route renders through this.
 *
 * The check used to live in App.js, which only ever rendered at `/` — so
 * Settings, Projects, Tags, Storage and Admin rendered for a signed-out visitor
 * (and during the auth check), firing API calls that could only fail.
 */
export default function AuthGate({ children }) {
    const { user, loading } = useContext(UserContext);

    // Hold on a neutral splash until Firebase has answered, so a returning user
    // doesn't see the login form flash before their session is restored.
    if (loading) {
        return <div className="loading-screen" role="status">Loading QDex…</div>;
    }
    if (!user) return <LoginForm />;
    return children;
}
